import React, { FC } from 'react';
import { CourseViewType } from 'src/state/courseListing/courseListingReducer';
import { CourseListingOnlineCoursesPagination } from 'src/public/components/course-listing/CourseListingCourseTypeListPagination/CourseListingOnlineCoursesPagination';
import { CourseListingElearningCoursesPagination } from 'src/public/components/course-listing/CourseListingCourseTypeListPagination/CourseListingElearningCoursesPagination';
import styled from 'styled-components';
import { CourseListingCourseBundlesPagination } from 'src/public/components/course-listing/CourseListingCourseTypeListPagination/CourseListingCourseBundlesPagination';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 2.5rem;
`;

export interface CourseListingCoursesSectionProps {
  viewType: CourseViewType.Online | CourseViewType.Elearning | CourseViewType.CourseBundle;
}

export const CourseListingCourseTypeListPagination: FC<CourseListingCoursesSectionProps> = ({
  viewType,
}) => (
  <Container>
    {viewType === CourseViewType.Online && <CourseListingOnlineCoursesPagination />}
    {viewType === CourseViewType.Elearning && <CourseListingElearningCoursesPagination />}
    {viewType === CourseViewType.CourseBundle && <CourseListingCourseBundlesPagination />}
  </Container>
);
